module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAARCAYAAAAyhueAAAAAAXNSR0IArs4c6QAAATpJREFUOBGtlDtLA1EQhefMXR+IjY1YGwR/gKWNEB9VuiDY2NmI4J/Rwkqw0kZdsBHBP2DrRkmhIhY2ERMQY7J3nF0TCGEfubLb7N453z17Zpm9oN4VXleOCbTVX/fu52bV3xyq5S4REXJfHQ/fvttJNJh3TfnyMElLq/2Z1vcm7NNLPRGCWBJ0ErXBItOVKfv7USk27d5UtiGyOMj851nEBN7axYknt9Vp22mX1D8/Tc6bQHZB7namPAp/NjTvfA4/uvz5vu5ZKwdCMjv6rmzSWlphRZrZmKMq0mRNWXPclokLocY6h0Em5SgCEhSfFJrUkFdoUiMUME12Hxw7TMUBEpqZe2Qs+y0QXlNJF0HwjKWjr2ik9NemQj5B3yc21QOgkLHS7mOf2JRJTtX4w6XTYVb3NxhjZ1H9Fz3uX5vIFMfqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/video.png
// module id = wa1j
// module chunks = 1